module.exports = __webpack_public_path__ + "static/img/13.4204d5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/13.png
// module id = h/3R
// module chunks = 1